import * as React from 'react';
import classNames from 'classnames/bind';

import '../variables.css';
import css from './button.module.css';

const cx = classNames.bind(css);

type Props = {
  variant: 'primary' | 'outline-primary' | 'secondary' | 'clear';

  /** Whether to render the component as a button (default) or as a link using `<a>` tag */
  type?: 'button' | 'link';

  /** Icon to render on the left side of the button. Typically, an `Icon` component should be passed */
  leftIcon?: React.ReactNode;

  /** Icon to render on the right side of the button. Typically, an `Icon` component should be passed */
  rightIcon?: React.ReactNode;

  fullWidth?: boolean;

  /** Whether button should be disabled or not */
  disabled?: boolean;

  /** Somewhat wider variant with extra padding on the sides */
  wider?: boolean;

  // FIXME: So, I'm not sure how we can conditionally alow button/a props based on the value/type of a prop.
  [key: string]: any;
};

/**
 * Primary UI component for user interaction
 */
export const Button: React.FC<Props> = props => {
  const {
    className,
    variant,
    leftIcon,
    rightIcon,
    type,
    fullWidth,
    wider,
    children,
    disabled,
    ...restProps
  } = props;

  const WrapperElement: React.ElementType = type === 'link' ? 'a' : 'button';

  let wrapperProps = {};

  if (type === 'button') {
    wrapperProps = {
      disabled,
      type: 'button' as const,
    };
  }

  return (
    <WrapperElement
      {...wrapperProps}
      className={cx(
        'button',
        variant,
        { disabled, wider, 'full-width': fullWidth },
        className
      )}
      {...restProps}
    >
      {leftIcon}
      <span className={cx('content')}>{children}</span>
      {rightIcon}
    </WrapperElement>
  );
};

Button.defaultProps = {
  type: 'button',
  fullWidth: false,
  wider: false,
};
